import {
  ExportAdjustments,
  ExportBOMs,
  ExportBuilds,
  ExportCustomers,
  ExportEstimates,
  ExportInvoices,
  ExportItems,
  ExportItemReceipts,
  ExportJobs,
  ExportLots,
  ExportPayments,
  ExportReturns,
  ExportRTVs,
  ExportRMAs,
  ExportSalesOrders,
  ExportSalesReceipts,
  ExportSerials,
  ExportTransfers,
  ExportPickTickets,
  ExportProcessTransactions,
  ExportPriceTiers,
  ExportPurchaseOrders,
  ExportShipments,
  ExportRentals,
  ExportRentalReturns,
  ExportUnitsOfMeasure,
  ExportVendorItemCatalog,
  ExportVendors,
  ExportWorkOrders,
} from "views/Exports/exportDefinitions/index";

export const EXPORTS = {
  ExportAdjustments,
  ExportBOMs,
  ExportBuilds,
  ExportCustomers,
  ExportEstimates,
  ExportInvoices,
  ExportItems,
  ExportItemReceipts,
  ExportJobs,
  ExportLots,
  ExportPayments,
  ExportReturns,
  ExportRTVs,
  ExportRMAs,
  ExportSalesOrders,
  ExportSalesReceipts,
  ExportSerials,
  ExportTransfers,
  ExportPickTickets,
  ExportProcessTransactions,
  ExportPriceTiers,
  ExportPurchaseOrders,
  ExportShipments,
  ExportRentals,
  ExportRentalReturns,
  ExportUnitsOfMeasure,
  ExportVendorItemCatalog,
  ExportVendors,
  ExportWorkOrders,
};

export const EXPORTS_BY_CATEGORY = [
  {
    categoryCode: "Inventory",
    planIncludesCategory: () => true,
    reports: [
      "ExportAdjustments",
      "ExportBOMs",
      "ExportItems",
      "ExportLots",
      "ExportSerials",
      "ExportTransfers",
      "ExportUnitsOfMeasure",
      "ExportVendorItemCatalog",
    ],
  },
  {
    categoryCode: "Purchasing",
    planIncludesCategory: () => true,
    reports: [
      "ExportVendors",
      "ExportPurchaseOrders",
      "ExportItemReceipts",
      "ExportRTVs",
    ],
  },
  {
    categoryCode: "Sales",
    planIncludesCategory: () => true,
    reports: [
      "ExportCustomers",
      "ExportEstimates",
      "ExportInvoices",
      "ExportSalesOrders",
      "ExportSalesReceipts",
      "ExportPayments",
      "ExportReturns",
      "ExportRMAs",
      "ExportPriceTiers",
    ],
  },
  {
    categoryCode: "Fulfillment",
    planIncludesCategory: () => true,
    reports: ["ExportShipments", "ExportPickTickets"],
  },
  {
    categoryCode: "Production",
    planIncludesCategory: () => true,
    reports: [
      "ExportBuilds",
      "ExportProcessTransactions",
      "ExportJobs",
      "ExportWorkOrders",
    ],
  },
  {
    categoryCode: "Rentals",
    planIncludesCategory: (plus, pro) => plus || pro,
    reports: ["ExportRentals", "ExportRentalReturns"],
  },
];
